import TextInputColumnFilter from "../../../shared/table/TextInputColumnFilter";
export const TABLE_COLUMNS = [
  {
    Header: "Lookup",
    accessor: "lookup",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Single Color Price",
    accessor: "singleColorPrice",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Multi Color Price",
    accessor: "multiColorPrice",
    Filter: TextInputColumnFilter,
  },
  {
    Header: "Actions",
    id: "Actions",
  },
];
